import { useAxios } from '@/services/kardAPI';
import { z } from 'zod';
import { baseURL } from './experiments';

/**
 * Offer Links Schemas
 */

const offerLinkAttributesSchema = z.object({
  experimentId: z.string(),
  offerId: z.string(),
  status: z.string(),
  rules: z.unknown(),
});

const offerLinkRequestSchema = z.object({
  type: z.literal('offer_link'),
  attributes: offerLinkAttributesSchema,
});

export type OfferLinkRequest = z.infer<typeof offerLinkRequestSchema>;

const offerLinkResponseSchema = z.object({
  id: z.string().uuid(),
  type: z.literal('offer_link'),
  attributes: offerLinkAttributesSchema,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type OfferLinkResponse = z.infer<typeof offerLinkResponseSchema>;
export const listOfferLinksResponseSchema = z.object({
  data: z.array(offerLinkResponseSchema),
});
export type ListOfferLinksResponse = z.infer<
  typeof listOfferLinksResponseSchema
>;

export const useOfferLinks = (experimentId: string) =>
  useAxios<ListOfferLinksResponse>({
    baseURL,
    url: '/offer-links',
    params: {
      experimentId,
    },

    method: 'GET',
  });

export const useCreateOfferLink = () =>
  useAxios<OfferLinkResponse, OfferLinkRequest>(
    {
      baseURL,
      url: '/offer-links',
      method: 'POST',
    },
    { manual: true },
  );

export const useUpdateOfferLink = (id: string) =>
  useAxios<OfferLinkResponse, OfferLinkRequest>(
    {
      baseURL,
      url: `/offer-links/${id}`,
      method: 'PUT',
    },
    { manual: true },
  );
